var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { useMemo } from 'react';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { WidgetType } from '@common/api';
import { generateKPIColumns } from '@main/dashboard/kpi/util';
import { widgetsApi } from '@data/rest/api';
import { KpiColumnType } from '@util/enums';
import { getMutationOptionsFactory } from '@util/query';
import { parseWidgetConfig } from './widgetConfig';
import { useActiveVersions } from '@data/hooks/versions';
import { useActiveYears } from '@data/hooks/timePoints';
import { useTagContext } from '@data/tag/tagContext';
import { evaluateTagProgram, Opcode, TagProgramBuilder } from '@data/tag/tagEvaluator';
export var widgetKeys = Object.freeze({
    all: ['widget'],
    lists: function () {
        return __spreadArray(__spreadArray([], __read(widgetKeys.all), false), ['list'], false);
    },
    list: function (filter) {
        if (filter === void 0) { filter = 'all'; }
        return __spreadArray(__spreadArray([], __read(widgetKeys.lists()), false), [filter], false);
    },
});
var mutationOptionsFactory = getMutationOptionsFactory();
function getWidgets() {
    return widgetsApi.list();
}
export function useWidgets(options) {
    return useQuery(widgetKeys.list(), getWidgets, __assign({ staleTime: 5000 }, options));
}
function createWidget(createWidgetData) {
    if (createWidgetData.type === WidgetType.KPI) {
        var widgetConfig = parseWidgetConfig(createWidgetData.config, createWidgetData.type);
        if (!widgetConfig.useSlicerData && widgetConfig.kpiCols.length === 0) {
            widgetConfig.kpiCols = [
                {
                    id: '1',
                    type: KpiColumnType.SELECTOR,
                    title: 'Default column',
                    hide: false,
                },
            ];
        }
        widgetConfig.uncollapsed = [];
        createWidgetData.config = JSON.stringify(widgetConfig);
    }
    else if (createWidgetData.type === WidgetType.SIMULATION || createWidgetData.type === WidgetType.DATAEDITOR) {
        var config = parseWidgetConfig(null, WidgetType.SIMULATION);
        createWidgetData = {
            title: '',
            type: createWidgetData.type,
            config: JSON.stringify(config),
            GridId: createWidgetData.GridId,
        };
    }
    return widgetsApi.create(createWidgetData);
}
export function useCreateWidget() {
    var key = widgetKeys.all;
    var queryClient = useQueryClient();
    var options = mutationOptionsFactory.create('create', key, queryClient);
    return useMutation(createWidget, options);
}
function cloneWidget(widget) {
    var copyData = {
        title: widget.title,
        type: widget.type,
        config: widget.config,
        GridId: widget.GridId,
    };
    return widgetsApi.create(copyData);
}
export function useCloneWidget() {
    var key = widgetKeys.all;
    var queryClient = useQueryClient();
    var options = mutationOptionsFactory.create('create', key, queryClient);
    return useMutation(cloneWidget, options);
}
function updateWidget(updatedWidget) {
    return __awaiter(this, void 0, void 0, function () {
        var id, rest;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    id = updatedWidget.id, rest = __rest(updatedWidget, ["id"]);
                    return [4 /*yield*/, widgetsApi.update(id, rest)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
export function useUpdateWidget() {
    var key = widgetKeys.list();
    var queryClient = useQueryClient();
    var options = mutationOptionsFactory.create('update', key, queryClient);
    return useMutation(updateWidget, options);
}
function deleteWidget(widgetId) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, widgetsApi._delete(widgetId)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
export function useDeleteWidget() {
    var key = widgetKeys.list();
    var queryClient = useQueryClient();
    var options = mutationOptionsFactory.create('delete', key, queryClient);
    return useMutation(deleteWidget, options);
}
export function useGetKPIColumnsFromSlicer() {
    var _a;
    var allWidgets = (_a = useWidgets().data) !== null && _a !== void 0 ? _a : [];
    var versions = useActiveVersions();
    var activeYears = useActiveYears();
    var versionsById = versions.reduce(function (map, version) {
        map[version.id] = version;
        return map;
    }, {});
    return function (gridId, internalTags) {
        var slicer = allWidgets.find(function (widget) { return widget.GridId === gridId && widget.type === WidgetType.SLICER; });
        if (slicer !== undefined && slicer.type === WidgetType.SLICER) {
            var slicerConfig = parseWidgetConfig(slicer.config, slicer.type);
            var kpiCols = generateKPIColumns(slicerConfig.periods, slicerConfig.intervalStart, slicerConfig.intervalEnd, slicerConfig.yearVersions, slicerConfig.yearVersionComparisons, slicerConfig.showSum, slicerConfig.comparisonOperation, activeYears, versionsById, internalTags);
            return kpiCols;
        }
        else {
            // no slicer on this grid
            return [];
        }
    };
}
function getGeneratedTags(generatorTagId, filterTagIds, tagData) {
    var e_1, _a;
    var allTags = tagData.tagsByParentId[generatorTagId] || [];
    if (allTags.length === 0) {
        return [];
    }
    var builder = new TagProgramBuilder();
    builder.addSetTable(generatorTagId).addLogicalTagOp(filterTagIds, Opcode.AND, Opcode.AND);
    var tagIds = evaluateTagProgram(tagData, builder.build());
    var gens = [];
    try {
        for (var allTags_1 = __values(allTags), allTags_1_1 = allTags_1.next(); !allTags_1_1.done; allTags_1_1 = allTags_1.next()) {
            var tag = allTags_1_1.value;
            if (tagIds.has(tag.id)) {
                gens.push(tag.id);
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (allTags_1_1 && !allTags_1_1.done && (_a = allTags_1.return)) _a.call(allTags_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return gens;
}
export function useTagSlicersData(gridId, localChanges) {
    var _a;
    var allWidgets = (_a = useWidgets().data) !== null && _a !== void 0 ? _a : [];
    var tagData = useTagContext().tagData;
    var tagSlicers = allWidgets.filter(function (w) { return w.GridId === gridId && w.type === WidgetType.TAGSLICER; });
    var configsKey = tagSlicers.map(function (_a) {
        var config = _a.config;
        return config;
    }).join(',');
    var _b = __read(useMemo(function () {
        var e_2, _a;
        var _b;
        var tagTableIdByWidgetId = {};
        var unfilteredAllTagIds = {};
        var filteredAllTagIds = {};
        var activeTagIds = {};
        try {
            for (var tagSlicers_1 = __values(tagSlicers), tagSlicers_1_1 = tagSlicers_1.next(); !tagSlicers_1_1.done; tagSlicers_1_1 = tagSlicers_1.next()) {
                var ts = tagSlicers_1_1.value;
                var tsConfig = parseWidgetConfig(ts.config, WidgetType.TAGSLICER);
                var tableId = tsConfig.tagSlicerTags[0];
                tagTableIdByWidgetId[ts.id] = tsConfig.tagSlicerTags[0];
                var filteredTagIds = getGeneratedTags(tableId, tsConfig.tagSlicerFilterTagIds, tagData);
                if (localChanges[ts.id]) {
                    activeTagIds[ts.id] = localChanges[ts.id];
                }
                else {
                    activeTagIds[ts.id] = tsConfig.tags ? tsConfig.tags : [];
                }
                var tableTagId = tsConfig.tagSlicerTags[0] || null;
                if (tableTagId) {
                    var tags = (_b = tagData.tagsByParentId[tableTagId]) !== null && _b !== void 0 ? _b : [];
                    unfilteredAllTagIds[ts.id] = tags.map(function (t) { return t.id; });
                    filteredAllTagIds[ts.id] = filteredTagIds;
                }
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (tagSlicers_1_1 && !tagSlicers_1_1.done && (_a = tagSlicers_1.return)) _a.call(tagSlicers_1);
            }
            finally { if (e_2) throw e_2.error; }
        }
        return [activeTagIds, tagTableIdByWidgetId, unfilteredAllTagIds, filteredAllTagIds];
    }, [gridId, configsKey, localChanges, tagData]), 4), activeTagIds = _b[0], tagTableIdByWidgetId = _b[1], unfilteredAllTagIds = _b[2], filteredAllTagIds = _b[3];
    return {
        activeTagIds: activeTagIds,
        unfilteredAllTagIds: unfilteredAllTagIds,
        filteredAllTagIds: filteredAllTagIds,
        tagTableIdByWidgetId: tagTableIdByWidgetId,
    };
}
